/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_File_Exam_NameInputs */

const da_forside_file_exam_name = /** @type {(inputs: Forside_File_Exam_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgavesæt`)
};

/** @type {(inputs: Forside_File_Exam_NameInputs) => LocalizedString} */
const en_forside_file_exam_name = da_forside_file_exam_name;

/**

* @param {Forside_File_Exam_NameInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_file_exam_name = /** @type {((inputs?: Forside_File_Exam_NameInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_File_Exam_NameInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_file_exam_name(inputs)
	return /** @type {LocalizedString} */ ("Opgavesæt")
});